import * as React from 'react'
import { DashboardNavConnected } from './DashboardNavConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DashboardNavExamples = () => {
  return (
    <div className="DashboardNavExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DashboardNavConnected />
      </Provider>
    </div>
  )
}
